import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { RouterModule } from '@angular/router';
import { CompanyBranchSelectorComponent, AlertComponent, InvoiceDetailModalComponent } from './_components';
import { IndianCurrencyPipe } from './_helpers/indian-currency.pipe';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AgGridModule,
        RouterModule
    ],
    declarations: [
        CompanyBranchSelectorComponent,
        AlertComponent,
        IndianCurrencyPipe,
        InvoiceDetailModalComponent
    ],
    exports: [
        CompanyBranchSelectorComponent,
        AlertComponent,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IndianCurrencyPipe,
        InvoiceDetailModalComponent,
        AgGridModule
    ]
})
export class SharedModule { }
